<template>
  <div class="main-container">
    <div v-if="embeddedUrlToken === ''" class="glass-card empty-state">
      <p id="noRecordsMessage">We are in the process of configuring your management dashboard.</p>
      <p id="noRecordsMessage">Please check back later.</p>
    </div>
    <div v-else class="frame-wrap glass-card">
      <iframe
        class="iframe"
        :src="`https://chat-dash.com/embed?token=${this.embeddedUrlToken}`"
        frameborder="0">
      </iframe>
    </div>
  </div>
</template>

<script>
// import { get } from 'axios';

export default {
  name: "AdminHome",
  data() {
    return {
      apiUrl: process.env.VUE_APP_MICROSERVICE_API_URL,
      showSpinner: false,
      embeddedUrlToken: "",
      user: null,
    };
  },
  created() {
    const userData = localStorage.getItem("customerRecord");
    // console.log("User Data:", userData);
    if (userData) {
      this.user = JSON.parse(userData);
    }
    if (this.user) {
      this.getEmbeddedUrlToken();
    } else {
      console.warn('No customer record found; cannot fetch embedded dashboard URL.');
    }
  },
  methods: {
    async getEmbeddedUrlToken() {
      try {
        this.showSpinner = true;
        const response = await fetch(`${this.apiUrl}/users/${this.user.id}/embedded-url-token`);
        const data = await response.json();
        this.embeddedUrlToken = data.embeddedUrl;
        // this.embeddedUrlToken = "testtoken";
        this.showSpinner = false;
      } catch (error) {
        console.error('Error fetching embedded URL token:', error);
      }
    }
  },
  mounted() {
    // Fallback in case created hook did not fire before mount
    if (!this.embeddedUrlToken && this.user) {
      this.getEmbeddedUrlToken();
    }
  }
};
</script>

<style scoped>
.main-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px;
  color: var(--text-primary);
}

h1 {
  font-size: 2.5rem;
  color: #27374D;
  margin-bottom: 1rem;
  text-align: center;
}

.empty-state {
  padding: 24px;
  text-align: center;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-2xl);
  box-shadow: var(--shadow-card);
  backdrop-filter: blur(10px);
}

#noRecordsMessage {
  margin-top: 8px;
  text-align: center;
  color: var(--text-secondary);
}

.frame-wrap {
  border: 1px solid var(--border-color);
  border-radius: var(--radius-2xl);
  box-shadow: var(--shadow-card);
  overflow: hidden;
  height: calc(100vh - 160px);
}

.iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
</style>
